import React, { FC, useState } from "react";
import * as Yup from "yup";
import { Button, DialogActions, DialogContent, TextField } from "@mui/material";
import {
  IMensagemRespostaLink,
  schemaMensagemRespostaLink,
  yupMensagemRespostaLink,
} from "@deltasge/marauders-map";

export const DialogRespostaLink: FC<{
  handleAddLink: (link: IMensagemRespostaLink) => void;
  idMensagemResposta: number | null;
}> = ({ handleAddLink, idMensagemResposta }) => {
  const [text, setText] = useState("");
  const [error, setError] = useState<string>();

  const validate = (url: string): boolean => {
    try {
      schemaMensagemRespostaLink.validateSync({
        ...yupMensagemRespostaLink.getDefault(),
        idMensagemResposta,
        url: url.indexOf("http") >= 0 ? url : "http://".concat(url),
      });
      setError(undefined);
      return true;
    } catch (e) {
      if (e as Yup.ValidationError)
        setError((e as Yup.ValidationError).message);
      else setError((e as Error).message);
      return false;
    }
  };

  return (
    <>
      <DialogContent dividers>
        <TextField
          label="URL"
          onKeyUp={({ key }) => {
            if (text.trim() == "") return;
            key == "Enter" && validate(text)
              ? handleAddLink({ url: text, idMensagemResposta })
              : null;
          }}
          onChange={({ target: { value } }) => setText(value)}
          value={text}
          error={!!error}
          helperText={error}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (text.trim() == "") return;
            if (!validate(text)) return;
            handleAddLink({ url: text, idMensagemResposta });
          }}
        >
          OK
        </Button>
      </DialogActions>
    </>
  );
};
